"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _toArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/toArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactUseIdHook = require("react-use-id-hook");
var _CompletedContext = require("../CompletedContext");
var _ = require("..");
require("./TaskPassageClick.css");
var _DesignComponents = require("../DesignComponents/DesignComponents");
var _FeedbackIcon = _interopRequireDefault(require("../FeedbackIcon/FeedbackIcon"));
var _questionMarkIcon = _interopRequireDefault(require("../assets/question-mark-icon.png"));
var _excluded = ["correct", "feedback", "finalFeedback", "children"];
var PassageClickContext = /*#__PURE__*/_react.default.createContext({});
function Click(_ref) {
  var correct = _ref.correct,
    feedback = _ref.feedback,
    finalFeedback = _ref.finalFeedback,
    children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var value = _react.default.useContext(PassageClickContext);
  var id = (0, _reactUseIdHook.useId)();
  _react.default.useEffect(function () {
    if (value.clickableElements === undefined) {
      return;
    }
    value.clickableElements[id] = correct ? true : false;
    return function () {
      if (value.clickableElements === undefined) {
        return;
      }
      delete value.clickableElements[id];
    };
  });
  if (value.clickableElements === undefined) {
    return /*#__PURE__*/_react.default.createElement("mark", rest, children);
  }
  var clickableKeys = Object.keys(value.clickableElements);
  var index = clickableKeys.indexOf(id);
  var clicked = value.clicked[index];
  var _children = (0, _toArray2.default)(children),
    first = _children[0],
    notfirst = _children.slice(1);
  var ariaLabelID = 1;
  for (var i = 0; i < clickableKeys.length; ++i) {
    if (clickableKeys[i] === id) {
      ariaLabelID = i;
    }
  }
  return /*#__PURE__*/_react.default.createElement("mark", Object.assign({}, rest, {
    id: id,
    className: "click" + (clicked ? " clicked" + (correct ? " correct" : " incorrect") : value.completed ? " disabled" : ""),
    tabIndex: !clicked || value.completed ? "0" : "-1",
    role: clicked || value.completed ? undefined : "button",
    "aria-label": "Highlight ".concat(ariaLabelID + 1),
    onClick: function onClick() {
      if (clicked || value.completed) {
        return;
      }
      value.onClick(id, correct, feedback, finalFeedback);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" || e.key === " ") {
        if (clicked) {
          return;
        }
        value.onClick(id, correct, feedback, finalFeedback);
        e.preventDefault();
      }
    }
  }), /*#__PURE__*/_react.default.createElement("span", null, clicked && /*#__PURE__*/_react.default.createElement(_FeedbackIcon.default, {
    correct: correct,
    iconSize: "12px"
  }), first), notfirst);
}
var TaskPassageClick = exports.default = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TaskPassageClick, _Component);
  var _super = (0, _createSuper2.default)(TaskPassageClick);
  function TaskPassageClick(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskPassageClick);
    _this = _super.call(this, props);
    _this.state = props.state || {};
    if (!_this.state.initialized) {
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = false;
      _this.state.showModal = false;
      _this.state.feedback = undefined;
      _this.state.correct = undefined;
      _this.state.clickableElements = {};
      _this.state.clicked = [];
    }
    _this.showInfo = _this.showInfo.bind((0, _assertThisInitialized2.default)(_this));

    // This gets set every time because `this` can change!
    _this.state.onClick = function (id, correct, feedback) {
      var clicked = _this.state.clicked.slice();
      var index = Object.keys(_this.state.clickableElements).indexOf(id);
      clicked[index] = true;
      for (var member in _this.state.clickableElements) {
        var i = Object.keys(_this.state.clickableElements).indexOf(member);
        if (_this.state.clickableElements[member] && !clicked[i]) {
          _this.setState({
            clicked: clicked,
            correct: correct ? true : false,
            feedback: feedback,
            completed: false
          });
          if (feedback) {
            _this.setState({
              showModal: true
            });
          }
          return;
        }
      }
      var numCorrect = 0;
      for (var _member in _this.state.clickableElements) {
        if (_this.state.clickableElements[_member] === true) {
          numCorrect += 1;
        }
      }
      if (numCorrect > 1 && _this.props.finalFeedback) {
        feedback = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, feedback), /*#__PURE__*/_react.default.createElement("p", null, _this.props.finalFeedback));
      }
      _this.setState({
        clicked: clicked,
        correct: correct ? true : false,
        feedback: feedback,
        completed: true,
        showModal: true
      });
    };
    return _this;
  }
  (0, _createClass2.default)(TaskPassageClick, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "showInfo",
    value: function showInfo() {
      this.setState({
        showInfo: true,
        showModal: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return /*#__PURE__*/_react.default.createElement("div", {
        key: this.props.key,
        className: "task task-passage-click",
        style: this.props.style
      }, /*#__PURE__*/_react.default.createElement("p", null, this.props.prompt, /*#__PURE__*/_react.default.createElement("div", {
        className: "passage-click-info",
        role: "button",
        tabIndex: "0",
        "aria-label": "Show icon key",
        onClick: this.showInfo,
        onKeyDown: function onKeyDown(e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            _this3.showInfo();
          }
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        style: {
          width: "20px",
          height: "20px",
          marginBottom: "4px",
          marginLeft: "4px"
        },
        alt: "",
        src: _questionMarkIcon.default
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "passage-click-contents"
      }, /*#__PURE__*/_react.default.createElement(PassageClickContext.Provider, {
        value: this.state
      }, this.props.children)), /*#__PURE__*/_react.default.createElement(_.ModalFeedback, {
        correct: this.state.showInfo ? undefined : this.state.correct,
        title: this.state.showInfo ? "Icon Key" : undefined,
        show: this.state.showModal,
        onHide: function onHide() {
          _this3.setState({
            showModal: false,
            showInfo: false,
            correct: undefined
          });
        }
      }, this.state.showInfo ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "These icons are used to differentiate answer feedback for passages:", /*#__PURE__*/_react.default.createElement("ul", {
        style: {
          listStyle: 'none'
        }
      }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_FeedbackIcon.default, {
        iconSize: "16px"
      }), " Incorrect"), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_FeedbackIcon.default, {
        correct: true,
        iconSize: "16px"
      }), " Correct"))) : this.state.feedback));
    }
  }]);
  return TaskPassageClick;
}(_react.Component);
TaskPassageClick.contextType = _CompletedContext.CompletedContext;
TaskPassageClick.Click = Click;